// extracted by mini-css-extract-plugin
export default {"facts":"styles_facts__KPzeF"};